import { ApiErrorCode } from '@neosocial/protocol';
import { ApiRequestError } from '../lib/api';

/**
 * A new password the server refused because it appeared in a data leak:
 * the field code `PASSWORD_LEAKED` under INVALID_FORM_BODY (what the server
 * sends), or the error code PASSWORD_LEAKED (100019).
 */
export function isLeakedPassword(e: unknown, field: string): boolean {
  if (!(e instanceof ApiRequestError)) return false;
  return e.fieldCodes()[field] === 'PASSWORD_LEAKED' || e.code === ApiErrorCode.PASSWORD_LEAKED;
}
